import Moderator from '@/models/bread/Moderator/accountInstitution'

export default {
  key:'Institution',
  server:'sso',
  name:{
    singular:'Institution',
    plural:'Institutions',
  },
  parents:[
    'Account',
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}